// React Required
import React, { Component } from 'react';
import ReactDOM from 'react-dom';

// Create Import File
import './index.scss';
import './i18n';

// Common Layout
// import Layout from "./component/common/App";

// Dark Home Layout 
import EcoShiftLanding from './home/EcoShiftLanding';

import { BrowserRouter, Switch, Route } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import FaqsLanding from './home/FaqsLanding';
// import AboutUsPage from './home/AboutUsPage';
import NatureOnTheBoardPage from './home/NatureOnTheBoardPage';
import PrivacyPage from './home/PrivacyPage';
import TermsPage from './home/TermsPage';
import TermsOfUsePage from './home/TermsOfUsePage';
import DataAccessPage from './home/DataAccessPage';
import { hydrate, render } from 'react-dom';
import LegalNoticePage from './home/LegalNoticePage';
import PressPage from './home/press/PressPage';
import PressArticlePage from './home/press/PressArticlePage';
import StoreRedirect from './home/StoreRedirect';


require('dotenv').config()

// Unregister service worker
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then(registration => {
    registration.unregister();
  });
}

class Root extends Component {
  componentDidMount() {
    // Check if the cookie already exists
    let lang = localStorage.getItem("lang")

    if (!lang) {
      console.log("No saved language, try to get system language");

      // Detect system/browser language
      lang = navigator.language || navigator.userLanguage || "en";

      // Optional: only keep the first part (e.g., "en-US" → "en")
      lang = lang.split("-")[0];
      if (lang != 'en' && lang != 'de' && lang != 'fr' && lang != 'nl') {
        lang = 'en'
      }
      localStorage.setItem("lang", lang);


      console.log("Detected and saved language:", lang);
    } else {
      console.log("Language from localStorage:", lang);
    }
  }

  render() {
    return (
      <BrowserRouter basename={'/'}>
        <Switch>
          <Route exact path={`${process.env.PUBLIC_URL}/`} component={EcoShiftLanding} />
          <Route exact path={`${process.env.PUBLIC_URL}/s`} component={StoreRedirect} />
          <Route exact path={`${process.env.PUBLIC_URL}/faqs`} component={FaqsLanding} />
          {/* <Route exact path={`${process.env.PUBLIC_URL}/about-us`} component={AboutUsPage}/> */}
          <Route exact path={`${process.env.PUBLIC_URL}/nature-on-the-board`} component={NatureOnTheBoardPage} />
          <Route exact path={`${process.env.PUBLIC_URL}/privacy`} component={PrivacyPage} />
          <Route exact path={`${process.env.PUBLIC_URL}/terms-of-use`} component={TermsOfUsePage} />
          <Route exact path={`${process.env.PUBLIC_URL}/terms`} component={TermsPage} />
          <Route exact path={`${process.env.PUBLIC_URL}/data-request`} component={DataAccessPage} />
          <Route exact path={`${process.env.PUBLIC_URL}/legal-notice`} component={LegalNoticePage} />
          <Route exact path={`${process.env.PUBLIC_URL}/press`} component={PressPage} />
          <Route exact path={`${process.env.PUBLIC_URL}/press/article`} component={PressArticlePage} />
        </Switch>
      </BrowserRouter>
    )
  }
}

//ReactDOM.render(<Root/>, document.getElementById('root'));
const rootElement = document.getElementById('root');
if (rootElement.hasChildNodes()) {
  hydrate(<Root />, rootElement);
} else {
  render(<Root />, rootElement);
}

serviceWorker.register();